module.exports = __webpack_public_path__ + "static/media/longarrowaltright.d6b1ff20.svg";